var map = {
	"./result_wine_a.png": "93f6",
	"./result_wine_b.png": "5011",
	"./result_wine_c.png": "9538",
	"./result_wine_d.png": "1dab",
	"./result_wine_e.png": "ffe5",
	"./result_wine_f.png": "d73c",
	"./result_wine_g.png": "6df9",
	"./result_wine_h.png": "5a5e",
	"./result_wine_i.png": "8924"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f26";